// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"a690edf3","453":"941ff5ef","549":"7478ec36"}[chunkId] + ".chunk.js";
};